"use strict";

/* -------------------------------------------------------------------------

	PUNITED.top

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.top) PUNITED.top = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.top;
  /* -----------------------------------------------------
         Hero section slider
     ----------------------------------------------------- */

  ns.heroSlider = function () {
    var splide = new Splide('.top_hero__bg .splide', {
      type: 'loop',
      gap: 16,
      fixedWidth: 620,
      arrows: false,
      pagination: false,
      drag: false,
      breakpoints: {
        679: {
          gap: 10,
          fixedWidth: 250
        }
      },
      autoScroll: {
        speed: .75,
        pauseOnHover: false,
        pauseOnFocus: false
      }
    });
    splide.mount(window.splide.Extensions); // splide.mount();
  };
  /* -----------------------------------------------------
         Job cards
     ----------------------------------------------------- */


  ns.jobCards = function () {
    var container = document.querySelector('.top_job_cards');
    var cards = container.querySelectorAll('.top_job_cards__card');
    var cardsAnim = [{
      card: cards[0],
      filter: cards[0].querySelector('.top_job_cards__filter'),
      text: cards[0].querySelector('.top_job_cards__caption'),
      containerProps: {
        transformOrigin: 'top left',
        xPercent: -5,
        rotate: 5
      },
      animProps: {
        xPercent: 150,
        yPercent: -20,
        rotate: -15
      }
    }, {
      card: cards[1],
      filter: cards[1].querySelector('.top_job_cards__filter'),
      text: cards[1].querySelector('.top_job_cards__caption'),
      containerProps: {
        transformOrigin: 'top center',
        xPercent: -5,
        rotate: 5
      },
      animProps: {
        xPercent: 125,
        yPercent: -15,
        rotate: -20
      }
    }, {
      card: cards[2],
      filter: cards[2].querySelector('.top_job_cards__filter'),
      text: cards[2].querySelector('.top_job_cards__caption'),
      containerProps: {
        transformOrigin: 'bottom center',
        xPercent: -5,
        rotate: -5
      },
      animProps: {
        xPercent: 75,
        yPercent: 10,
        rotate: 15
      }
    }];
    var cardsFilter = [.6, .3, 0];
    var tl; // ScrollTrigger.create({
    // 	trigger: container,
    // 	start: 'top 50%',
    // 	end: '+=1',
    // 	once: true,
    // 	markers: true,
    // 	onToggle: (self) => {
    // 		if (self.isActive) {

    animate(); // 		}
    // 	}
    // });

    function animate() {
      var card = cardsAnim.pop();
      cardsAnim.unshift(card);
      var xPercent = card.animProps.xPercent;
      var yPercent = card.animProps.yPercent;
      var rotate = card.animProps.rotate;

      if (tl) {
        tl.kill();
      }

      tl = gsap.timeline({
        onComplete: function onComplete() {
          setTimeout(function () {
            return animate();
          }, 2000);
        }
      }).to(container, {
        transformOrigin: card.containerProps.transformOrigin,
        xPercent: "+=".concat(card.containerProps.xPercent),
        // yPercent: `+=`,
        rotate: "+=".concat(card.containerProps.rotate),
        duration: .5,
        ease: 'power2.in'
      });
      cardsAnim.forEach(function (card, i) {
        tl.to(card.filter, {
          opacity: cardsFilter[i],
          duration: .5,
          ease: 'power2.in'
        }, '<');
        tl.to(card.text, {
          color: i === cardsAnim.length - 1 ? '#333' : '#fff',
          duration: .5,
          ease: 'power2.in'
        }, '<');
      });
      tl.to(card.card, {
        xPercent: "+=".concat(xPercent),
        yPercent: "+=".concat(yPercent),
        rotate: "+=".concat(rotate),
        duration: .5,
        ease: 'power2.in'
      }, '<').call(function () {
        var length = cardsAnim.length;
        cardsAnim.forEach(function (card, i) {
          card.card.style.zIndex = "".concat(i - length);
        });
      }).to(container, {
        transformOrigin: card.containerProps.transformOrigin,
        xPercent: "-=".concat(card.containerProps.xPercent),
        // yPercent: `+=`,
        rotate: "-=".concat(card.containerProps.rotate),
        duration: .5,
        ease: 'power2.out'
      }).to(card.card, {
        xPercent: "-=".concat(xPercent),
        yPercent: "-=".concat(yPercent),
        rotate: "-=".concat(rotate),
        duration: .5,
        ease: 'power2.out'
      }, '<');
    }
  };
  /* -----------------------------------------------------
         Image slider
     ----------------------------------------------------- */


  ns.interviewSlider = function () {
    var splide = new Splide('.top_interview_slider .splide', {
      type: 'loop',
      perPage: 1,
      gap: "".concat(16 / 375 * 100, "%"),
      padding: "".concat((375 - 280) / 2 / 375 * 100, "%"),
      arrows: false,
      pagination: false,
      mediaQuery: 'min',
      breakpoints: {
        680: {
          destroy: true
        }
      }
    });
    splide.mount();
  };
  /* -----------------------------------------------------
  	----------------------------------------------------- */


  ns.moviesSlider = function () {
    var container = document.querySelector('.top_movie_slider');
    var slider = container.querySelector('.swiper');
    var slides = slider.querySelectorAll('.swiper-slide');
    var pcWidth = 660;
    var pcGapRatio = (40 / pcWidth + 1) * 100;
    var swiper = null;
    var mq = PUNITED.common.mediaQuery;
    init(mq.matches);
    mq.addEventListener('change', function (e) {
      init(e.matches);
    });

    function init(isSp) {
      if (swiper !== null) {
        swiper.destroy();
        swiper = null;
      }

      var clonedSlides = slider.querySelectorAll('.swiper-slide.--clone');
      clonedSlides.forEach(function (clone) {
        return clone.remove();
      });

      if (isSp) {
        return;
      }

      var min = 6;
      var length = slides.length;

      if (length < min) {
        var repeat = Math.floor(min / length);

        for (var i = 0; i < repeat; i++) {
          slides.forEach(function (slide) {
            var clone = slide.cloneNode(true);
            clone.classList.add('--clone');
            slide.parentNode.append(clone);
          });
        }
      }

      swiper = new Swiper(slider, {
        loop: true,
        // autoplay: true,
        centeredSlides: true,
        slidesPerView: 3,
        navigation: {
          prevEl: container.querySelector('.splide__arrow--prev'),
          nextEl: container.querySelector('.splide__arrow--next')
        },
        effect: 'creative',
        creativeEffect: {
          limitProgress: 2,
          prev: {
            scale: 560 / pcWidth,
            translate: ["-".concat(pcGapRatio, "%"), 0, 0],
            origin: 'bottom right'
          },
          next: {
            scale: 560 / pcWidth,
            translate: ["".concat(pcGapRatio, "%"), 0, 0],
            origin: 'bottom left'
          }
        },
        on: {// 	init: () => {
          // 		PUNITED.utils.refreshScrollTriggerPosition();
          // 	},
          // 	resize: () => {
          // 		PUNITED.utils.refreshScrollTriggerPositionDebounced();
          // 	},
          // 	setTranslate: (swiper, translate) => {
          // 		console.debug(translate);
          // 	}
        }
      });
    }
  };
})();

$(function () {
  PUNITED.top.heroSlider();
  PUNITED.top.jobCards();
  PUNITED.top.interviewSlider();
  PUNITED.top.moviesSlider();
});